import { gate } from 'hub-http/gates';
export const SUBSCRIPTIONS_RECORD_PAYMENT_GATE = gate('Subscriptions:RecordPaymentAutomaticPaymentSubscription');
export const NON_BILLABLE_GATE = gate('commerce:invoices:nonBillable:M1');
export const NO_DRAFT_ON_CREATE_GATE = gate('commerce:invoices:noDraftOnCreate');
export const INVOICE_PREVIEW_GATE = gate('commerce:invoices:invoicePreview');
export const INVOICE_PERMISSIONS_GATE = gate('Permissions:Invoices');